import { render } from "./ShareButton.vue?vue&type=template&id=c5869212&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"

import "./ShareButton.vue?vue&type=style&index=0&id=c5869212&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5869212"]])

export default __exports__